"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorRole = exports.imageRole = exports.classes = void 0;
var classes = {
  snackbarContainer: 'snackbar-container',
  snackbar: 'snackbar',
  imageTitle: 'snackbar-image-title',
  title: 'snackbar-title',
  errorList: 'snackbar-error-list',
  errorListContainer: 'error-list-container',
  detailsContainer: 'details-container',
  closeIcon: 'snackbar-close-icon'
};
exports.classes = classes;
var imageRole = 'imageIcon';
exports.imageRole = imageRole;
var errorRole = 'errorItem';
exports.errorRole = errorRole;